import { parse } from 'url';
const SSO_ERR_STATUS = 401;
const AUTH_ERR_CODE = 403;
const baseURL = process.env.VUE_APP_API;
function convertObjtoUrlSearch(data) {
    let _result = [];
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            let value = data[key];
            if (value.constructor === Array) {
                value.forEach(_value => {
                    _result.push(key + '=' + _value);
                });
            }
            else {
                _result.push(key + '=' + value);
            }
            return _result.join('&');
        }
    }
}
const responseInterceptor = async (res) => {
    if (res.status >= 300) {
        throw new Error(`${res.status} Error happens`);
    }
    if (res.status === 204) {
        return { code: 0, data: 'SUCCESS' };
    }
    if (res.status !== 200) {
        return res;
    }
    const result = await res.json();
    if (result.status === SSO_ERR_STATUS) {
        // 这是 SSO 的拦截处理
        throw new Error('认证失败，请刷新页面！');
    }
    if (result.code === AUTH_ERR_CODE) {
        // 这是鉴权的拦截处理
        const url = parse(res.url);
        throw new Error(`没有接口 ${url.pathname} 的权限，请联系管理员申请！`);
    }
    return result;
};
const responseBuffer = async (res) => {
    if (res.status >= 300) {
        throw new Error(`${res.status} Error happens`);
    }
    if (res.status === 204) {
        return { code: 0, data: 'SUCCESS' };
    }
    if (res.status !== 200) {
        return res;
    }
    const result = await res.arrayBuffer();
    return result;
};
const getInstance = async ({ url = '', params = {} }) => {
    const fetchUrl = convertObjtoUrlSearch(params)
        ? `${baseURL}${url}?${convertObjtoUrlSearch(params)}`
        : `${baseURL}${url}`;
    const res = await fetch(fetchUrl);
    return responseInterceptor(res);
};
const postInstance = ({ url = '', body = {}, headers = {} }) => fetch(`${baseURL}${url}`, {
    method: 'POST',
    headers: {
        'content-type': 'application/json',
        ...headers,
    },
    body: JSON.stringify(body),
}).then(responseInterceptor);
const getBuffer = async ({ url = '', params = {} }) => {
    const fetchUrl = convertObjtoUrlSearch(params)
        ? `${baseURL}${url}?${convertObjtoUrlSearch(params)}`
        : `${baseURL}${url}`;
    const res = await fetch(fetchUrl);
    return responseBuffer(res);
};
export { getInstance as get, postInstance as post, getBuffer };
